module.exports = __webpack_public_path__ + "img/FMR.2badb1d2.svg";